/* eslint-disable camelcase */
import React from 'react';

import DrawEditPageV2 from './DrawEditPageV2';

const DrawEditPageWrapper = (props) => {
    return <DrawEditPageV2 {...props} />;
};

export default DrawEditPageWrapper;
